import { render, staticRenderFns } from "./module-clean.vue?vue&type=template&id=32f5c40c&"
import script from "./module-clean.vue?vue&type=script&lang=js&"
export * from "./module-clean.vue?vue&type=script&lang=js&"
import style0 from "./module-clean.vue?vue&type=style&index=0&id=32f5c40c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports